import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-charcoal border-t-2 border-amber shadow-2xl">
      <div className="flex items-center gap-2 p-3">
        <a
          href="tel:+61414995458"
          className="flex-1 flex items-center justify-center gap-2 bg-cream text-charcoal font-display font-bold uppercase tracking-wider text-sm py-3 px-4 rounded-lg hover:bg-amber transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          Call Now
        </a>
        <Link
          to="/contact"
          className="flex-1 bg-jp-red text-cream font-display font-bold uppercase tracking-wider text-sm py-3 px-4 rounded-lg hover:bg-jp-red/90 transition-colors text-center"
        >
          Get Quote
        </Link>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
